import api from "@/lib/api";
import {
  PostApplicationContractResponse,
  PostIceApplicationPayContractResponse,
  PostOffersActivationCodeWacomContractResponse,
  PostOffersActivationCodeWacomContractStripeBillingResponse,
  PostOffersContinuedPatronageContractResponse,
  PostOffersDebutContractResponse,
  PostOffersWacomContractResponse,
  PostPaymentInformationEditResponse,
  PostSaleContractResponse,
  PutPaymentInformationEditResponse
} from "@/containers/paymentInformationRegisterStripe/Responses";
import {
  PostApplicationContractRequest,
  PostIceApplicationPayContractRequest,
  PostOffersActivationCodeWacomContractRequest,
  PostOffersActivationCodeWacomContractStripeBillingRequest,
  PostOffersContinuedPatronageContractRequest,
  PostOffersDebutContractRequest,
  PostOffersWacomContractRequest,
  PostPaymentInformationEditRequest,
  PostSaleContractRequest,
  PutPaymentInformationEditRequest
} from "@/containers/paymentInformationRegisterStripe/Requests";

export default {
  // 新規契約登録 API
  postApplicationContract(data: any) {
    return api<PostApplicationContractRequest, PostApplicationContractResponse>(
      {
        endpoint: "application/web-api/contract-st",
        method: "POST",
        body: data
      }
    );
  },

  // V1買い切りユーザ向けの月額利用優待登録 API
  postOffersContinuedPatronageContract(data: any) {
    return api<
      PostOffersContinuedPatronageContractRequest,
      PostOffersContinuedPatronageContractResponse
    >({
      endpoint: "offers/continued-patronage/web-api/contract",
      method: "POST",
      body: data
    });
  },

  // DEBUT版のアクティベーションコードを持っているユーザーの月額PRO優待登録 API
  postOffersDebutContract(data: any) {
    return api<PostOffersDebutContractRequest, PostOffersDebutContractResponse>(
      {
        endpoint: "offers/debut-st/web-api/contract",
        method: "POST",
        body: data
      }
    );
  },

  // Wacom優待用登録 API
  postOffersActivationCodeWacomContract(data: any) {
    return api<
      PostOffersActivationCodeWacomContractRequest,
      PostOffersActivationCodeWacomContractResponse
    >({
      endpoint: "offers/activation-code-st/wacom/web-api/contract",
      method: "POST",
      body: data
    });
  },

  // Wacom優待用登録 API(Stripe Billing)
  postOffersActivationCodeWacomContractStripeBilling(data: any) {
    return api<
      PostOffersActivationCodeWacomContractStripeBillingRequest,
      PostOffersActivationCodeWacomContractStripeBillingResponse
    >({
      endpoint: "offers/activation-code/wacom/web-api/contract",
      method: "POST",
      body: data
    });
  },

  // 支払い情報登録 API
  postPaymentInformationEdit(data: any) {
    return api<
      PostPaymentInformationEditRequest,
      PostPaymentInformationEditResponse
    >({
      endpoint: "payment-informations/web-api/edit",
      method: "POST",
      body: data
    });
  },

  // 支払い情報変更 API
  putPaymentInformationEdit(data: any) {
    return api<
      PutPaymentInformationEditRequest,
      PutPaymentInformationEditResponse
    >({
      endpoint: "payment-informations/web-api/edit-st",
      method: "PUT",
      body: data
    });
  },

  // V1買い切りユーザ向けの月額利用優待登録 API
  postOffersWacomContract(data: PostOffersWacomContractRequest) {
    return api<PostOffersWacomContractRequest, PostOffersWacomContractResponse>(
      {
        endpoint: "offers/wacom/web-api/contract",
        method: "POST",
        body: data
      }
    );
  },

  // PAYセール対応の契約登録 API
  postSaleContract(data: PostSaleContractRequest) {
    return api<PostSaleContractRequest, PostSaleContractResponse>({
      endpoint: "sale-st/web-api/contract",
      method: "POST",
      body: data
    });
  },

  // HUAWEI端末からの購入導線用登録 API
  postIceApplicationPayContract(data: any) {
    return api<
      PostIceApplicationPayContractRequest,
      PostIceApplicationPayContractResponse
    >({
      endpoint: "ice/application-pay/web-api/contract",
      method: "POST",
      body: data
    });
  }
};
